export default __webpack_public_path__ + "static/media/3.102a4fe5.jpg";